module.exports = __webpack_public_path__ + "media/images/flags/64/Bhutan-96335eb8590210f6def6235ee29e01df.png";